import * as tslib_1 from "tslib";
import { OnDestroy, OnInit } from '@angular/core';
import { SidenavService } from '@core/services/sidenav.service';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import moment from 'moment';
import { merge, Subject } from 'rxjs';
import { concatMap, debounceTime, tap } from 'rxjs/operators';
import { ReportFilterState } from '../components/filter/services/report-filter-state.service';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
import { QueryDashboardEquipmentsDataGQL } from './services/api/queries.service';
var DashboardEquipmentsComponent = /** @class */ (function () {
    function DashboardEquipmentsComponent(sidenavService, fuseTranslationLoaderService, reportFilterState, fuseProgressBarService, queryDashboardEquipmentsDataGQL) {
        this.sidenavService = sidenavService;
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.reportFilterState = reportFilterState;
        this.fuseProgressBarService = fuseProgressBarService;
        this.queryDashboardEquipmentsDataGQL = queryDashboardEquipmentsDataGQL;
        this.isLoading = true;
        this.equipmentsIndicatorData = null;
        this.subscriptions = new Subject();
        this.reloadEvent = new Subject();
    }
    DashboardEquipmentsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
        this.isFilterOn = this.reportFilterState.isFilterOn;
        merge(this.reportFilterState.onChangeFilter, this.reloadEvent)
            .pipe(debounceTime(200))
            .pipe(tap(function () { return _this.showLoading(); }))
            .pipe(concatMap(function () { return _this.updateData(); }))
            .pipe(tap(function () { return _this.hideLoading(); }))
            .subscribe();
        this.reload();
    };
    DashboardEquipmentsComponent.prototype.ngOnDestroy = function () {
        this.subscriptions.next();
        this.subscriptions.complete();
    };
    DashboardEquipmentsComponent.prototype.reload = function () {
        this.reloadEvent.next();
    };
    DashboardEquipmentsComponent.prototype.clearFilters = function () {
        this.reportFilterState.onClearFilter.next();
    };
    DashboardEquipmentsComponent.prototype.updateData = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.queryDashboardEquipmentsDataGQL
                            .fetch({ where: this.getWhere(this.reportFilterState.query) })
                            .toPromise()];
                    case 1:
                        data = (_a.sent()).data;
                        this.equipmentsIndicatorData = this.mapMaintenanceStaticsData(data);
                        return [2 /*return*/];
                }
            });
        });
    };
    DashboardEquipmentsComponent.prototype.mapMaintenanceStaticsData = function (data) {
        var items = data.accountMaintenancesStatistics.items;
        return {
            mtbf: this.findItemValue(items, 'mtbf'),
            mttr: this.findItemValue(items, 'mttr'),
            availability: this.findItemValue(items, 'availability')
        };
    };
    DashboardEquipmentsComponent.prototype.findItemValue = function (items, key) {
        var foundItem = items.find(function (item) { return item.key === key; });
        return foundItem ? foundItem.value : 0;
    };
    DashboardEquipmentsComponent.prototype.showLoading = function () {
        this.isLoading = true;
        this.fuseProgressBarService.show();
    };
    DashboardEquipmentsComponent.prototype.hideLoading = function () {
        this.isLoading = false;
        this.fuseProgressBarService.hide();
    };
    DashboardEquipmentsComponent.prototype.getWhere = function (query) {
        if (!query.openedAt_gte) {
            query.openedAt_gte = moment().subtract(1, 'month').startOf('days').toDate();
        }
        if (!query.openedAt_lte) {
            query.openedAt_lte = moment().startOf('days').toDate();
        }
        var where = {
            from: moment(query.openedAt_gte).startOf('day').format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
            to: moment(query.openedAt_lte).endOf('day').format('YYYY-MM-DDTHH:mm:ss.SSSZ')
        };
        if (query.locationId_in && query.locationId_in.length) {
            where.locationId_in = query.locationId_in;
        }
        if (query.locationGroupId_in && query.locationGroupId_in.length) {
            where.locationGroupId_in = query.locationGroupId_in;
        }
        if (query.companyId_in && query.companyId_in.length) {
            where.companyId_in = query.companyId_in;
        }
        if (query.segmentId_in && query.segmentId_in.length) {
            where.segmentId_in = query.segmentId_in;
        }
        if (query.typeId_in && query.typeId_in.length) {
            where.typeId_in = query.typeId_in;
        }
        if (query.scheduledAt_gte) {
            where.scheduledAt_gte = query.scheduledAt_gte;
        }
        if (query.scheduledAt_lte) {
            where.scheduledAt_lte = query.scheduledAt_lte;
        }
        if (query.closedAt_gte) {
            where.closedAt_gte = query.closedAt_gte;
        }
        if (query.closedAt_lte) {
            where.closedAt_lte = query.closedAt_lte;
        }
        return where;
    };
    return DashboardEquipmentsComponent;
}());
export { DashboardEquipmentsComponent };
